export default __webpack_public_path__ + "static/media/icon_default@4x.c11b0c12.png";